import { Link } from "react-router-dom"
import { useTraduction } from "../../Contexte/TraductionContext";

function Actualite() {
    const {contentAccueil, contentBlog} = useTraduction()
    const articles = contentBlog.Articles || []
    const lastThreeArticles = articles.slice(-3);

    return <>
    <section id="Actualite" className="container mt-124">
        <h3>{contentAccueil.GrosTitreActualite}</h3>
        
        <div className="cards mt-64">

            {lastThreeArticles.map((item, index) => (
                <Link style={{marginLeft: "0px"}} className="card" to={"blog/" + item.Lien}>
                <img loading="lazy" src={item.Image} alt=""/>
                <div className="containerInfo">
                    <p className="News">{item.Date}</p>
                    <p className="Title mt-16">{item.Titre}</p>
                    <p className="Descriptif">{item.Description}</p>
                    <Link>
                        {contentAccueil.BoutonActualite}
                    </Link>
    
                </div>
                
                </Link>

            ))}
            
        </div>

        
    </section>
</>
}

export default Actualite